<p-confirmDialog [style]="{ width: '450px' }" />

<p-toolbar styleClass="mb-4 gap-2 top-action-bar" [style]="{'z-index': '2'}">
    <ng-template pTemplate="left">
        <div class="flex align-items-center gap-2">
            <p-button label="Send emails" icon="pi pi-at" severity="success" (onClick)="sendEmails()" />
        </div>
    </ng-template>

    <ng-template pTemplate="right">
        <div class="flex align-items-center gap-2">
            <div class="flex flex-row gap-2 col-12 lg:col-6">
                <label style="white-space: nowrap" for="onlyNotSent">Show Only not sent</label>
                <p-checkbox [(ngModel)]="onlyNotSent" id="onlyNotSent" [binary]="true" />
            </div>
        </div>
    </ng-template>
</p-toolbar>

<p-table #dt2 [value]="data | customerTabFilter:onlyNotSent" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true"
    [rows]="20" [first]="0" [showCurrentPageReport]="true" [rowHover]="true" dataKey="id" [totalRecords]="data.length"
    [globalFilterFields]="['error', 'customerVAT', 'customerName']" [scrollable]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

    <ng-template #caption>
        <div style="display: flex; justify-content: space-between;">
            <h3 class="m-0">Accounting Tabs for {{ date }}</h3>

            <p-iconfield iconPosition="left" class="ml-auto">
                <p-inputicon>
                    <i class="pi pi-search"></i>
                </p-inputicon>
                <input pInputText type="text" (input)="filterGlobal($event)" placeholder="Search keyword" />
            </p-iconfield>
        </div>
    </ng-template>

    <ng-template #header>
        <tr>
            <th>Customer</th>
            <th pSortableColumn="customerVAT">
                VAT <p-sortIcon field="customerVAT" />
            </th>
            <th pSortableColumn="thirdPartyAmount">
                Third Party Amount <p-sortIcon field="thirdPartyAmount" />
            </th>
            <th pSortableColumn="licenceAmount">
                Licence Amount <p-sortIcon field="licenceAmount" />
            </th>
            <th pSortableColumn="totalAmount">
                Total Amount <p-sortIcon field="totalAmount" />
            </th>
            <th pSortableColumn="warning">
                Warning <p-sortIcon field="warning" />
            </th>
            <th pSortableColumn="error">
                Error <p-sortIcon field="error" />
            </th>

            <th>Related Deals</th>

            <th>Email</th>
            <th>Date Sent</th>

            <th></th>
        </tr>
    </ng-template>
    <ng-template #body let-item>
        <tr>
            <td>{{ item.customerName }}</td>
            <td>{{ item.customerVAT }}</td>
            <td>{{ item.thirdPartyAmount }}</td>
            <td>{{ item.licenceAmount }}</td>
            <td>{{ item.totalAmount }}</td>
            <td>{{ item.warning }}</td>
            <td>{{ item.error }}</td>
            <td>
                <div class="flex flex-row gap-2">
                    <span *ngFor="let deal of item.relatedDeals">
                        <a [href]="'/deals/edit/' + deal?.crmid">{{ deal?.crmid }}</a>
                    </span>
                </div>
            </td>
            <td>
                <span *ngIf=" item.notifications.length> 0" class="flex flex-row gap-2">
                    <span *ngIf="item.notifications.length > 0">{{ item.notifications[0].to }}</span>
                </span>
            </td>
            <td>
                <span *ngIf="item.notifications.length > 0 && item.notifications[0].dateSent != null">{{
                    item.notifications[0].dateSent | date:
                    'dd/MM/yyyy HH:mm' }}</span>

                <i *ngIf="item.notifications.length > 0 &&item.notifications[0].errorMessage != null && item.notifications[0].errorMessage != ''"
                    class="pi pi-times" [title]="item.notifications[0].errorMessage"></i>
            </td>
            <td>
                <div class="flex flex-row gap-2">
                    <a *ngIf="item.error == null || item.error == ''" (click)="preview($event, item)"
                        href="#">Preview</a>
                    <a style="color: red"
                        *ngIf="item.notifications.length == 0 || item.notifications[0].dateSent == null"
                        (click)="deleteEntry($event, item)" href="#">Delete</a>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [(visible)]="nowLoadingModal" [modal]="true" header="Please wait" [closable]="false">

    <div class="flex" style="align-items: center; gap: 20px">
        <div>
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
        <p>Sending emails, please wait...</p>
    </div>

</p-dialog>

<p-dialog [(visible)]="testEmailModal" [modal]="true" header="Send Test email">

    <div class="flex" style="align-items: center; gap: 20px">
        <input [(ngModel)]="testEmail" pInputText class="w-full" type="email" placeholder="Email" />
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Send" icon="pi pi-send" (click)="sendTestEmail()" severity="warn"></p-button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="displayEmailPreview" [modal]="true" header="Preview Email" [style]="{width: '50vw'}">
    <div class="p-fluid flex flex-column gap-4" *ngIf="emailData != null">
        <!-- To Field -->
        <div class="p-field flex flex-column gap-2">
            <label for="to">To</label>
            <input pInputText class="w-full" id="to" type="email" (ngModelChange)="testEmailDirty = true"
                [(ngModel)]="emailData.recipient" placeholder="Recipient Email" />
        </div>

        <div class="p-field flex flex-column gap-2">
            <label>cc</label>
            <input pInputText class="w-full" type="email" (ngModelChange)="testEmailDirty = true"
                [(ngModel)]="emailData.cc" placeholder="CC Email" />
        </div>

        <!-- Subject Field -->
        <div class="p-field flex flex-column gap-2">
            <label for="subject">Subject</label>
            <input pInputText class="w-full" id="subject" type="text" (ngModelChange)="testEmailDirty = true"
                [(ngModel)]="emailData.subsject" placeholder="Email Subject" />
        </div>

        <!-- Message Field -->
        <div class="p-field flex flex-column gap-2">
            <label for="message">Message</label>
            <p-editor [(ngModel)]="emailData.body" (ngModelChange)="testEmailDirty = true"
                [style]=" { height: '420px' }">
            </p-editor>
        </div>

        <!-- Attachments -->
        <div class="p-field flex flex-column gap-2">
            <label for="attachment">Attachments</label>
            <div *ngFor="let attachment of emailData.attatchments">
                <p-tag icon="pi pi-file" value="{{ attachment.name }}" [style]="{ cursor: 'pointer' }"
                    (click)="downloadFile(attachment)" />
            </div>
        </div>
    </div>

    <!-- Footer Buttons -->
    <ng-template pTemplate="footer">
        <p-button *ngIf="selectedItem != null && selectedItem.notifications != null &&
            selectedItem.notifications.length > 0 && selectedItem.notifications[0].dateSent == null" label="Send"
            [disabled]="testEmailDirty" icon="pi pi-send" (click)="sendEmail()" severity="warn"></p-button>
        <p-button label="Save Custom" (click)="saveCustomContent()" class="p-button-text"></p-button>
        <p-button label="Send Test Email" [disabled]="testEmailDirty" (click)="testEmailModal = true"
            class="p-button-text"></p-button>
        <p-button label="Cancel" icon="pi pi-times" (click)="displayEmailPreview = false"
            class="p-button-text"></p-button>
    </ng-template>
</p-dialog>